var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-info-component',{attrs:{"title":_vm.$t('pages.dashboard.widgets.payroll_for_sign'),"value":_vm.value,"is-loading":_vm.isLoading,"icon":"fa-file-invoice-dollar","tone":"warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }